import type { HTMLAttributes, ReactNode } from 'react';

export interface InputLabelProps extends Omit<HTMLAttributes<HTMLDivElement>, 'color'> {
  icon?: ReactNode;
  required?: boolean;
  extra?: ReactNode;
  optional?: ReactNode;
  size?: 'normal' | 'big';
  requiredColor?: 'gray' | 'red';
  color?: 'light' | 'medium';
}
